import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { selectBalancingResource } from "../../balancingSelectors/selectBalancingResources";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ButtonDefault } from "../generic/button-buy/ButtonDefault";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { ButtonPrimaryMedium } from "../generic/common/ButtonPrimaryMedium";
import { ButtonSecondaryMedium } from "../generic/common/ButtonSecondaryMedium";
import { getResourceIcon } from "../generic/icon/getResourceIcon";
import { TextLoca } from "../generic/text/TextLoca";
import { actionBuyImprovement } from "./actionImprovement";
import { getImprovementCosts } from "./ImprovementUpgradeRequirements";
var _ButtonBuyImprovement = function (_a) {
    var onBuyImprovementStandard = _a.onBuyImprovementStandard, onBuyImprovementPremium = _a.onBuyImprovementPremium, item = _a.item;
    var isImprovementBuyableWithGold = item.balancing.level[item.level].premium != undefined;
    if (!isImprovementBuyableWithGold) {
        return (React.createElement("div", { className: "button-ribbon" },
            React.createElement(ButtonPrimary, { onClick: onBuyImprovementStandard },
                React.createElement(TextLoca, { id: IdLoca.buy, className: IdStyles.TextButtonDefault }))));
    }
    var improvementGoldCost = item.balancing.level[item.level]
        .premium.cost[0];
    var resource = selectBalancingResource(improvementGoldCost.resourceId);
    var icon = getResourceIcon(resource);
    return (React.createElement("div", { className: "button-ribbon" },
        React.createElement(ButtonDefault, { onClick: onBuyImprovementPremium, component: ButtonSecondaryMedium, amount: improvementGoldCost.amount, icon: icon }),
        React.createElement(ButtonPrimaryMedium, { onClick: onBuyImprovementStandard },
            React.createElement(TextLoca, { id: IdLoca.buy, className: IdStyles.TextButtonDefault }))));
};
var mapDispatch = function (dispatch, _a) {
    var item = _a.item, buildingId = _a.buildingId;
    var balancing = item.balancing, level = item.level;
    var improvementCost = (getImprovementCosts(balancing, level) || []).map(function (_a) {
        var amount = _a.amount, resourceId = _a.resourceId;
        return ({
            amount: Long.fromNumber(amount),
            typeId: resourceId,
        });
    });
    var improvementPremiumCost = balancing.level[level].premium
        ? balancing.level[level].premium.cost.map(function (_a) {
            var amount = _a.amount, resourceId = _a.resourceId;
            return ({
                amount: Long.fromNumber(amount),
                typeId: resourceId,
            });
        })
        : improvementCost;
    return {
        onBuyImprovementPremium: function () {
            return dispatch(actionBuyImprovement(balancing.id, improvementPremiumCost, buildingId, true));
        },
        onBuyImprovementStandard: function () {
            return dispatch(actionBuyImprovement(balancing.id, improvementCost, buildingId, false));
        },
    };
};
export var ButtonBuyImprovement = connect(undefined, mapDispatch)(_ButtonBuyImprovement);



//////////////////
// WEBPACK FOOTER
// ./src/features/improvement/ButtonBuyImprovement.tsx
// module id = 2689
// module chunks = 3